import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AuthShell } from "./AuthShell";
import { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function OrganizerRegister() {
  const { registerOrganizer } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", confirm_password: "", organization_name: "", website: "", phone: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (form.password !== form.confirm_password) { setError("Passwords do not match"); return; }
    setBusy(true);
    try {
      await registerOrganizer(form);
      toast.success("Organizer account created!");
      nav("/organizer", { replace: true });
    } catch (e2) { setError(formatApiError(e2.response?.data?.detail) || e2.message); }
    finally { setBusy(false); }
  };

  return (
    <AuthShell title="List Your Race" subtitle="Create your organizer account">
      <form onSubmit={submit} className="space-y-4">
        {error && <div className="bg-red-50 text-red-600 text-sm p-3 rounded-lg" data-testid="org-register-error">{error}</div>}
        <div className="grid grid-cols-2 gap-3">
          <div><label className="text-sm font-semibold text-slate-700">Your Name</label>
            <input required value={form.name} onChange={set("name")} data-testid="org-name" className="mt-1 w-full border border-slate-300 rounded-lg px-4 py-3 focus:border-[#22d3ee] outline-none" /></div>
          <div><label className="text-sm font-semibold text-slate-700">Phone</label>
            <input required value={form.phone} onChange={set("phone")} data-testid="org-phone" className="mt-1 w-full border border-slate-300 rounded-lg px-4 py-3 focus:border-[#22d3ee] outline-none" /></div>
        </div>
        <div><label className="text-sm font-semibold text-slate-700">Organization Name</label>
          <input required value={form.organization_name} onChange={set("organization_name")} data-testid="org-organization" className="mt-1 w-full border border-slate-300 rounded-lg px-4 py-3 focus:border-[#22d3ee] outline-none" /></div>
        <div><label className="text-sm font-semibold text-slate-700">Email</label>
          <input type="email" required value={form.email} onChange={set("email")} data-testid="org-email" className="mt-1 w-full border border-slate-300 rounded-lg px-4 py-3 focus:border-[#22d3ee] outline-none" /></div>
        <div><label className="text-sm font-semibold text-slate-700">Website (optional)</label>
          <input value={form.website} onChange={set("website")} placeholder="https://" className="mt-1 w-full border border-slate-300 rounded-lg px-4 py-3 focus:border-[#22d3ee] outline-none" /></div>
        <div className="grid grid-cols-2 gap-3">
          <div><label className="text-sm font-semibold text-slate-700">Password</label>
            <input type="password" required minLength={6} value={form.password} onChange={set("password")} data-testid="org-password" className="mt-1 w-full border border-slate-300 rounded-lg px-4 py-3 focus:border-[#22d3ee] outline-none" /></div>
          <div><label className="text-sm font-semibold text-slate-700">Confirm Password</label>
            <input type="password" required minLength={6} value={form.confirm_password} onChange={set("confirm_password")} data-testid="org-confirm-password" className="mt-1 w-full border border-slate-300 rounded-lg px-4 py-3 focus:border-[#22d3ee] outline-none" /></div>
        </div>
        <button disabled={busy} data-testid="org-register-submit"
          className="w-full bg-[#22d3ee] text-[#0a1420] font-bold py-3 rounded-lg hover:bg-[#06b6d4] transition-colors disabled:opacity-60">
          {busy ? "Creating…" : "Create Organizer Account"}
        </button>
      </form>
      <p className="text-center text-sm text-slate-500 mt-6">Already an organizer? <Link to="/login" className="text-[#06b6d4] font-semibold hover:underline">Log In</Link></p>
    </AuthShell>
  );
}
